import { Component, Inject, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-question-multiple-choice',
  templateUrl: './question-multiple-choice.component.html',
  styleUrls: ['./question-multiple-choice.component.scss']
})
export class QuestionMultipleChoiceComponent implements OnInit {
  @Input() multipleChoiceForm: FormGroup;
  @Input() isEditValue: boolean;
  @Output() media = new EventEmitter();
  @Output() qMedia = new EventEmitter();
  @Output() qMediaType = new EventEmitter();

  questionMediaType: string;
  questionMedia;
  choicesMedia = [];
  modalData;
  vdoDuration;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    console.log(this.multipleChoiceForm);
    if (this.isEditValue) {
      // ใส่ในนี้
      this.questionMediaType = this.modalData.value.VALUE[0].media.media_type;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.multipleChoiceFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required],
            media: {
              media_type: this.modalData.value.VALUE[0].choices[i].media.media_type,
              file_name: this.modalData.value.VALUE[0].choices[i].media.file_name,
              file_url: this.modalData.value.VALUE[0].choices[i].media.file_url
            },
          })
        )
      }

      this.multipleChoiceForm.controls['media'].setValue(this.modalData.value.VALUE[0].media);
      // console.log(this.multipleChoiceForm.value);
    }
  }

  addChoiceAndImg(form) {
    form.push(
      this.fb.group({
        media: {
          media_type: '',
          file_name: ''
        },
        choice_detail: ['', Validators.required],
        choice_id: form.value.length + 1
      })
    );
  }

  getDuration(e) {
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      this.vdoDuration = video.duration;
    }
    video.src = URL.createObjectURL(e.target.files[0]);
  }


  addQuestionMedia(e, form) {
    // console.log(e);

    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    this.questionMediaType = fileType;
    // // console.log(fileType);
    // console.log(form);
    // console.log(e.target.files[0]);

    if (fileType === 'mp4') {
      this.getDuration(e);
    }

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg' || fileType === 'mp3' || fileType === 'mp4' || fileType === 'wav') {
      setTimeout(() => {
        if (e.target.files && e.target.files[0]) {
          const file = (e.target as HTMLInputElement).files[0];
          const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

          // console.log(fileType);

          form.controls['media'].patchValue({
            media_type: type,
            file_name: file.name,
            unlimit: '',
            time_again: '',
            duration: this.vdoDuration,
            vdo_id: '',
            file_url: ''
          });

          // console.log(form);

          form.controls['media'].updateValueAndValidity();
          this.questionMedia = file;
          this.qMedia.emit(this.questionMedia);
          this.qMediaType.emit(this.questionMediaType);
        }
      }, 300);
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG, MP3, MP4, WAV เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }


  addChoiceMedia(e, form) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    // console.log(e);
    // // console.log(e.target.value.replace(/^.*\\/, ""));

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {

      if (e.target.files && e.target.files[0]) {
        const file = (e.target as HTMLInputElement).files[0];
        const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

        form.controls['media'].patchValue({
          media_type: type,
          file_name: file.name,
        });
        form.controls['media'].updateValueAndValidity();
        this.choicesMedia.push(file);
        // console.log(this.choicesMedia);

        this.media.emit(this.choicesMedia);
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  get multipleChoiceFormArray(): FormArray {
    return this.multipleChoiceForm.get('choices') as FormArray;
  }

  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })
  }

  deleteImgChoice(form, index) {
    this.choicesMedia = this.choicesMedia.filter(m => form.at(index).get('media').value.file_name !== m.name);

    form.at(index).get('media').reset({
      media_type: '',
      file_name: '',
      file_url: ''
    });
    this.media.emit(this.choicesMedia);
  }

  deleteImgQuestion(form) {
    this.questionMedia = '';
    this.questionMediaType = '';

    form.get('media').reset({
      media_type: '',
      file_name: '',
      time_again: '',
      unlimit: '',
      file_url: ''
    });
    this.qMedia.emit(this.questionMedia);
    this.qMediaType.emit(this.questionMediaType);
  }

  clearValueDate(form) {
    if (!form.value.media.unlimit) {
      form.get('media').patchValue({ time_again: '' });
    }
  }

  setTimeAgain(form, e) {
    if (e.target.value > 0)
      form.get('media').patchValue({ time_again: e.target.value });
    else
      form.get('media').patchValue({ time_again: 0 });
  }
}
